import React, { useRef } from "react";
import { AppStoreContext } from "./context";
import { AppStore, createAppStore } from "../createAppStore";
import { AppProps } from "../states";

type AppStoreProviderProps = React.PropsWithChildren<{
  appProps?: Partial<AppProps>;
}>;

export const AppStoreProvider = ({ appProps, children }: AppStoreProviderProps) => {
  const storeRef = useRef<AppStore>(createAppStore(appProps));
  return <AppStoreContext.Provider value={storeRef.current}>{children}</AppStoreContext.Provider>;
};
